var Illusion = {
  handle: 'illusion',

  abilities: {
    sleight_of_hand: {
      handle: 'sleight_of_hand',
      unlockLevel: 1,
    },

    angel_mask: {
      handle: 'angel_mask',
      unlockLevel: 7,
      passive: true,
    },

    psyche_out: {
      handle: 'psyche_out',
      unlockLevel: 15,
    },

    infect_mind: {
      handle: 'infect_mind',
      unlockLevel: 23,
    },

    devil_mask: {
      handle: 'devil_mask',
      unlockLevel: 31,
    },

    blurred_form: {
      handle: 'blurred_form',
      unlockLevel: 39,
      passive: true,
    },

    faux_self: {
      handle: 'faux_self',
      unlockLevel: 47,
    },
  },
};
module.exports = Illusion;